import { V1 } from './net'
import { StoreThunkAction } from 'store/state'
import { Observable } from 'rxjs'
import { ContentType } from 'shared'

export type PostedPostsAction = 'archive' | 'unarchive' | 'favorite' | 'unfavorite'

export function postedAction(
  action: PostedPostsAction,
  ids: string[],
  ppids: string[],
  all?: boolean,
  bucketId?: string,
  query?: string,
  types?: ContentType[]
): StoreThunkAction<Observable<any>> {
  return (dispatch) => dispatch(V1.postedAction(action, ids, ppids, all, bucketId, query, types))
}
